import {
  Box,
  Columns,
  Container,
  Heading,
  Stack,
  Text,
} from '@spaceship-fspl/components/src';
import { fontWeight } from '@spaceship-fspl/styles';
import { TrackingCategory } from '@spaceship-fspl/tracking';
import { PanelSection } from 'components';
import React from 'react';
import styled from 'styled-components';

const RatingDescription = styled(Text)`
  max-width: 540px;
  ${fontWeight(500)};
`;

const LogoImg = styled.img`
  max-width: 100%;
  height: auto;
`;

interface RatingPanelProps {
  title: string;
  description: string;
  imageUrl: string;
}

export const RatingPanel: React.FC<
  React.PropsWithChildren<RatingPanelProps>
> = ({ title, description, imageUrl }) => {
  return (
    <TrackingCategory category="Rating Panel">
      <PanelSection paddingTop="none">
        <Container>
          <Columns alignX="center">
            <Columns.Column width={{ xs: 1, lg: 10 / 12 }}>
              <Box
                backgroundColor="neutral.015"
                borderRadius="sm"
                padding={{ xs: 'md', md: 'lg', lg: 'xl' }}
                width="100%"
              >
                <Columns
                  spaceX={{ xs: 'none', md: 'sm', lg: 'lg' }}
                  spaceY={{ xs: 'md', md: 'none' }}
                  alignY="center"
                  alignX="center"
                >
                  <Columns.Column width={{ xs: 1, md: 1 / 3, lg: 2 / 6 }}>
                    <Box display="flex" justifyContent="center">
                      <LogoImg
                        src={imageUrl}
                        alt="Spaceship Rainmaker AAA 2021 quality rating"
                      />
                    </Box>
                  </Columns.Column>
                  <Columns.Column width={{ xs: 1, md: 2 / 3, lg: 4 / 6 }}>
                    <Stack spaceY="sm" alignX={{ xs: 'center', md: 'left' }}>
                      <Heading variant={2} align={{ xs: 'center', md: 'left' }}>
                        {title}
                      </Heading>
                      <RatingDescription
                        variant={2}
                        color="neutral.085"
                        align={{ xs: 'center', md: 'left' }}
                      >
                        {description}
                      </RatingDescription>
                    </Stack>
                  </Columns.Column>
                </Columns>
              </Box>
            </Columns.Column>
          </Columns>
        </Container>
      </PanelSection>
    </TrackingCategory>
  );
};
